/**
 * @file Planboard drag source appointments component
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { DragSourceAppointmentsBaseComponent } from '../drag-source-appointments-base/drag-source-appointments-base.component';
import { DomainService } from '../../domain.service';
import { ExecutorsService } from '../executors.service';
import { AlertsService } from '../../core/alerts.service';
import { GridService } from '../grid.service';
/** Planboard drag source appointments component. */
var PlanboardDragSourceAppointmentsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PlanboardDragSourceAppointmentsComponent, _super);
    /**
     * Constructs PlanboarDragSourceAppointmentsComponent.
     * @param configurationsService The configuration service to get the configuration of this component.
     * @param router The router to synchronize query parameters with component state.
     */
    function PlanboardDragSourceAppointmentsComponent(domainService, executorsService, alertsService, gridService) {
        var _this = _super.call(this, domainService, executorsService, alertsService, gridService) || this;
        _this._selectedTeam = null;
        _this.initiateExecutors();
        return _this;
    }
    Object.defineProperty(PlanboardDragSourceAppointmentsComponent.prototype, "selectedTeam", {
        get: function () {
            return this._selectedTeam;
        },
        set: function (value) {
            if (this._selectedTeam === value) {
                return;
            }
            this._selectedTeam = value;
            this.refresh();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlanboardDragSourceAppointmentsComponent.prototype, "teamOid", {
        get: function () {
            if (this._selectedTeam == null) {
                return '?';
            }
            return this._selectedTeam['Oid'];
        },
        enumerable: true,
        configurable: true
    });
    return PlanboardDragSourceAppointmentsComponent;
}(DragSourceAppointmentsBaseComponent));
export { PlanboardDragSourceAppointmentsComponent };
